import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@leylion/design-system/styles.css";
import "./styles.css";
import { RootApp } from "./RootApp";
import { installSessionExpiryBoundary } from "./auth/session-expiry-boundary";
import { SessionContextBoundary } from "./auth/SessionContextBoundary";

installSessionExpiryBoundary();

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element was not found.");
}

createRoot(root).render(
  <StrictMode>
    <SessionContextBoundary><RootApp /></SessionContextBoundary>
  </StrictMode>
);
